export const APPLICATION_STATUS = {
  INCOMPLETE: 'Incomplete',
}

export const APPLICATION_STATUS_ACTIONS = {
  CREATE_ACCOUNT: 'CREATE_ACCOUNT',
  COMPLETE_PROFILE: 'COMPLETE_PROFILE',
  SAVE_PAYMENT: 'SAVE_PAYMENT',
  INVITE_FRIEND: 'INVITE_FRIEND',
}
